<template>
  <vbtTable
    ref="topicTable"
    class="round-table"
    isBigData
    :data="tableData"
    height="490"
    style="width: 100%;"
    border
    v-loading="tableLoad"
    element-loading-spinner="el-icon-loading"
    element-loading-text="列表加载中"
    :row-class-name="tableRowClassName"
  >
    <vbt-table-column width="40" align="right">
      <template slot="header" slot-scope="scope">
        <el-checkbox @change="selectAll(scope,$event)" v-model="selectAllTemp"></el-checkbox>
      </template>
      <template slot-scope="scope">
        <el-checkbox
          v-if="!scope.row.quoteCodeParent"
          @change="selectOne(scope.row,$event)"
          v-model="scope.row.checked"
        ></el-checkbox>
        <el-checkbox v-else @change="selectTwo(scope.row,$event)" v-model="scope.row.checked"></el-checkbox>
      </template>
    </vbt-table-column>
    <template v-for="(item,index) in tableHeaders">
      <vbt-table-column
        :key="item.fieldColumnName"
        :label="item.fieldName"
        :prop="item.fieldColumnName"
        :width="item.fieldName==='单价'&&form.quoteType==='2'?'150':item.fieldName==='供应商'?'210':'90'"
        align="center"
      >
        <template slot-scope="scope" >
          <template v-if="index===0&&!scope.row.quoteCodeParent">
            <span class="caret" @click.stop="showDetail(scope.row)" :key="item.key">
              <i class="el-icon-caret-right" v-if="!scope.row.showSubTable"></i>
              <i class="el-icon-caret-bottom" v-if="scope.row.showSubTable"></i>
            </span>
          </template>
          <el-input-number v-if="item.fieldName==='单价'&&scope.row.quoteCodeParent!==''&&form.quoteType==='2'" :class="scope.row.unitPrice<0?'input-price input-error':'input-price'"
                        :disabled="scope.row.relationLevel!==null" v-model="scope.row.unitPrice" @change="totalPrice(scope.row)"
                        controls-position="right" :precision="form.quotePrecision||0" :step="1"  :max="9999999999" ></el-input-number>
          <span v-else>{{ scope.row[item.fieldColumnName]}}</span>
        </template>
      </vbt-table-column>
    </template>
  </vbtTable>
</template>
<script>
import { getManageDetails } from '../../../api/tenderDetails.js';
import { vbtTable, vbtTableColumn } from 'vbt-table';
export default {
    components: { vbtTable, vbtTableColumn },
    props: {
        tableData: {
            type: Array
        },
        tableHeaders: {
            type: Array
        },
        form: {
            type: Object
        },
        selectAllType: {
            type: Boolean
        },
        tableLoad: {
            type: Boolean
        },
        allowQuote: {
            type: String
        },
        dictData: {
            type: Object
        }
    },
    data() {
        return {
            selectedRowsData: [],
            selectAllTemp: false
        };
    },
    methods: {
        // 选中的行高亮
        tableRowClassName({ row }) {
            if (this.selectedRowsData && this.selectedRowsData.includes(row)) {
                return 'highlight-row';
            }
        },
        formatData(data) {
            data.map(item => {
                item.tenderStatus_ = this.dictData.BID_SU_TENDER_STATUS[item.tenderStatus];
                item.quoteType_ = this.dictData.BID_SU_TENDER_TYPE[item.quoteType];
                item.shortlist = this.dictData.BID_WON_STATUS[item.shortlist];
            });
            return data;
        },
        async showDetail(row) {
            row.showSubTable = !row.showSubTable;
            this.$emit('load', true);
            const index = this.tableData.indexOf(row);
            if (!row.children && row.showSubTable) { // 展开,请求子节点
                const res = await getManageDetails({ tenderCode: this.form.tenderCode, allowQuote: this.allowQuote, parent: false, quoteCodes: [row.quoteCode] });
                row.children = res.data[0].children;
                row.children = this.formatData(row.children);
                if (row.checked) {
                    row.children.forEach(item => {
                        item.checked = row.checked;
                    });
                }
                this.common();
                this.$emit('load', false);
                this.tableData.splice(index + 1, 0, ...row.children);
            } else if (row.children && row.showSubTable) { // 展开,有子节点
                this.tableData.splice(index + 1, 0, ...row.children);
                this.$emit('load', false);
            } else { // 缩回
                this.tableData.splice(index + 1, row.children.length);
                this.$emit('load', false);
            }
        },
        selectAll(row, val) {
            this.selectAllTemp = val;
            this.tableData.forEach(item => {
                item.checked = val;
                if (item.children) {
                    item.children.forEach(item2 => {
                        item2.checked = val;
                    });
                }
            });
            const selectedRow = this.tableData.filter(item => { return item.checked; });
            this.selectedRowsData = selectedRow;
            this.$emit('selectAllChange', val, selectedRow);
        },
        common() {
            const table = this.tableData.filter(item => { return !item.quoteCodeParent; });
            var count = 0;
            let selectedRow = table.filter(item => { return item.checked; });
            selectedRow.forEach(item => {
                if (item.children) {
                    selectedRow = selectedRow.concat(item.children);
                }
            });
            for (let i = 0; i < table.length; i++) {
                if (table[i].checked) { count++; }
            }
            if (count === table.length) {
                this.selectAllTemp = true;
                this.selectedRowsData = selectedRow;
                this.$emit('selectAllChange', true, selectedRow);
            } else {
                this.selectAllTemp = false;
                this.selectedRowsData = selectedRow;
                this.$emit('selectAllChange', false, selectedRow);
            }
        },
        selectOne(row, val) { // 父节点勾选框;
            row.checked = val;
            if (row.children) {
                row.children.forEach(item => {
                    item.checked = val;
                });
            }
            this.common();
        },
        selectTwo(row, val) { // 子节点勾选框
            row.checked = val;
            const table = this.tableData.filter(item => { return item.quoteCode === row.quoteCodeParent; });
            this.selectOne(table[0], val);
        },
        totalPrice(row) {
            var multiplyReg = RegExp(/\*/);// 关联公式是*乘积时
            var divideReg = RegExp(/\//);// 关联公式是/除法时
            if (!row.unitPrice) {
                row.lineAmountTotal = 0;
            } else { row.lineAmountTotal = (row.unitPrice * row.expectTraffic).toFixed(this.form.quotePrecision); }
            const table = this.tableData.filter(item => { return item.quoteCode === row.quoteCodeParent; });
            table[0].lineAmountTotal = 0;
            table[0].children.forEach(item => {
                if (item.relationLevel === row.bidLevel) {
                    if (row.unitPrice === undefined) {
                        item.unitPrice = undefined; item.lineAmountTotal = 0;
                    } else if (row.unitPrice === 0) {
                        item.unitPrice = 0; item.lineAmountTotal = 0;
                    } else {
                        if (multiplyReg.test(item.relationFormula)) {
                            const multiplyVal = item.relationFormula.slice(1);
                            item.unitPrice = row.unitPrice * multiplyVal;
                        } else if (divideReg.test(item.relationFormula)) {
                            const divideVal = item.relationFormula.slice(1);
                            item.unitPrice = row.unitPrice / divideVal;
                        } else {
                            item.unitPrice = row.unitPrice * 1 + (item.relationFormula * 1);
                        }
                        item.lineAmountTotal = (item.unitPrice * item.expectTraffic).toFixed(this.form.quotePrecision);
                    }
                }
                table[0].lineAmountTotal += item.lineAmountTotal * 1;
            });
            table[0].lineAmountTotal = table[0].lineAmountTotal.toFixed(this.form.quotePrecision);
        }
    },
    computed: {
        loginState: function() { return this.$store.state.bidData; }
    },
    watch: {
        selectAllType(newVal, oldVal) {
            this.selectAllTemp = newVal;
        }
    }
};
</script>
<style lang="less">
.round-table{
    .cell {
        display: flex;
        .post-input div:first-child{
        display: flex
    }
    .el-input-group__append{
        display: flex
        }
    }
    .highlight-row {
        background: #e6f8f9 !important;
    }

}
</style>